import { track } from "./core"
import { trackingEventNames } from '../../settings/constants';

export function track_login() {
	const event = {
		event: trackingEventNames.LOGIN,
	};
	track(event);
}

export function track_login_start() {
	const event = {
		event: trackingEventNames.LOGIN_START,
	};
	track(event);
}

export function track_sign_up_start() {
	const event = {
		event: trackingEventNames.SIGN_UP_START,
	};
	track(event);
}

export function track_sign_up() {
	const event = {
		event: trackingEventNames.SIGN_UP,
	};
	track(event);
}